import React, { useCallback, useEffect, useState } from "react";
import Body from "src/components/common/Body";
import Box from "src/components/common/Box";
import SVG from "src/utils/SVG";
import IconButton from "src/components/common/IconButton";
import ApprovalListItem from "src/components/home/ApprovalListItem";
import ShopAsItem from "src/components/home/ShopAsItem";
import ComEstimateItem from "src/components/home/ComEstimateItem";
import ComVisitItem from "src/components/home/ComVisitItem";
import LogoFnf from "src/assets/images/logoFnf.svg";
import LogoFnfBlack from "src/assets/images/logoFnfBlack.svg";
import LogoMlb from "src/assets/images/logoMlb.svg";
import LogoMlbBlack from "src/assets/images/logoMlbBlack.svg";
import LogoMlbKids from "src/assets/images/logoMlbKids.svg";
import LogoMlbKidsBlack from "src/assets/images/logoMlbKidsBlack.svg";
import LogoDiscovery from "src/assets/images/logoDiscovery.svg";
import LogoDiscoveryBlack from "src/assets/images/logoDiscoveryBlack.svg";
import LogoDv from "src/assets/images/logoDv.svg";
import LogoDvBlack from "src/assets/images/logoDvBlack.svg";
import LogoSa from "src/assets/images/logoSa.svg";
import LogoSaBlack from "src/assets/images/logoSaBlack.svg";
import cn from "classnames";
import styled from "styled-components";
import {
  useAsCountQuery,
  useAsHopeListQuery,
  useAsMustListQuery,
  useAsOneDayListQuery,
  useAsProgressListQuery,
  useCompleteListQuery,
  useEstimateListQuery,
  useNoticeListQuery,
} from "src/api/homeAPI";
import { useAppDispatch, useAppSelector } from "src/store/actions/action";
import { asHopeListSet, asListSet, estimateListSet, completeListSet, homeNoticeListSet, setNoticeSlideIndex } from "src/store/reducers/homeReduce";
import { getCookie } from "src/utils/cookieUtil";
import { useNavigate } from "react-router-dom";
import AsStatusItem from "src/components/home/AsStatusItem";
import AlarmButton from "src/components/common/AlarmButton";
import { useAllBannerQuery } from "src/api/bannerAPI";
import MainBanner from "src/components/common/MainBanner";
import NoticeSlide from "src/components/notice/NoticeSlide";
import { useAlarmSettingListQuery } from "src/api/alarmAPI";
import Loading from "../Loading";
import Select from "../../components/common/Select";
import BookMarkButton from "../../components/common/BookMarkButton";

interface homeInit {
  employSkip: boolean;
  storeSkip: boolean;
  manuSkip: boolean;
  [prop: string]: any;
}

const brands = [
  { value: "", name: "전체" },
  { value: "M", name: "MLB" },
  { value: "I", name: "MLB KIDS" },
  { value: "X", name: "Discovery" },
  { value: "V", name: "DUVETICA" },
  { value: "W", name: "SUPRA" },
  { value: "ST", name: "Sergio Tacchini" },
];

const serverIp = process.env.REACT_APP_SERVER_IP;
const serverImageIp = process.env.REACT_APP_IMAGE_SERVER_IP;
const currentEnv = process.env.REACT_APP_ENV;
function renewalHome() {
  // 라이브러리 값 세팅
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  // 초기 값 세팅
  const userInfo = useAppSelector((state) => state.userReduce.userInfo);

  const [isScrollTop, setIsScrollTop] = useState(true);
  const [hasAlarm, setHasAlarm] = useState(false);
  const [banner, setBanner] = useState<string>();

  const Logo: any = {
    M: LogoMlb,
    MBlack: LogoMlbBlack,
    X: LogoDiscovery,
    XBlack: LogoDiscoveryBlack,
    I: LogoMlbKids,
    IBlack: LogoMlbKidsBlack,
    V: LogoDv,
    VBlack: LogoDvBlack,
    A: LogoSa,
    ABlack: LogoSaBlack,
    fnf: LogoFnf,
    fnfBlack: LogoFnfBlack,
  };

  // 해더 매장 타입 정리
  const [storeType, setStoreType] = useState({
    storeTypeName: "",
  });
  const { storeTypeName } = storeType;

  const [init, setInit] = useState<homeInit>({
    employSkip: true,
    storeSkip: true,
    manuSkip: true,
  });

  const reduceApiData = useAppSelector((state) => state.fileReduce.apiData);

  useEffect(() => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify({ ac_token: getCookie("ac_token"), re_token: getCookie("re_token") }));
      userInfo.name &&
        userInfo.user_id &&
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            actionType: "USER",
            name: userInfo.name,
            id: userInfo.user_id,
            email: userInfo.email ?? userInfo.user_id + "@fnfcorp.com",
          }),
        );
    }
  }, []);

  // banner API
  const allBanner = useAllBannerQuery({ skip: true });

  useEffect(() => {
    if (allBanner.isSuccess) {
      let count = 0;
      for (let i = 0; i < allBanner.data.data.length; i++) {
        if (userInfo.brand === allBanner.data.data[i].brand) {
          setBanner(serverImageIp + allBanner.data.data[i].img_url);
          break;
        } else {
          count = count + 1;
        }
      }
      if (count === allBanner.data.data.length) {
        setBanner("https://vmd-dev.fnf.co.kr/attachment/as/2022/5/2/9355ee38-2ecb-4f52-9763-09784323d006.png");
      }
    }
  }, [allBanner.isSuccess]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll); //clean up
    };
  }, [isScrollTop]);

  if (userInfo.user_type === "E") {
    // E = 본사
    useEffect(() => {
      setInit({
        ...init,
        employSkip: false,
      });
    }, []);
  } else if (userInfo.user_type === "S") {
    // S = 매장
    useEffect(() => {
      setInit({
        ...init,
        storeSkip: false,
      });
      if (userInfo.store_type === "A") {
        setStoreType({ storeTypeName: "백화점" });
      } else if (userInfo.store_type === "B") {
        setStoreType({ storeTypeName: "대리점" });
      } else if (userInfo.store_type === "C") {
        setStoreType({ storeTypeName: "직영점" });
      } else if (userInfo.store_type === "O") {
        setStoreType({ storeTypeName: "상설" });
      } else if (userInfo.store_type === "OL") {
        setStoreType({ storeTypeName: "아울렛" });
      } else if (userInfo.store_type === "ADF") {
        setStoreType({ storeTypeName: "면세점" });
      } else if (userInfo.store_type === "E") {
        setStoreType({ storeTypeName: "직영점" });
      }
    }, []);
  } else if (userInfo.user_type === "M") {
    // M = 업체
    useEffect(() => {
      setInit({
        ...init,
        manuSkip: false,
      });
    }, []);
  }

  // 클릭 이벤트 세팅
  const handleScroll = useCallback(() => {
    if (window.scrollY >= 50) {
      setIsScrollTop(false);
      return;
    } else {
      setIsScrollTop(true);
      return;
    }
  }, [isScrollTop]);

  // ========================================== 본사 로직 ==========================================
  const { employSkip } = init;

  // 본사 홈화면 설정
  const alarmSetList = useAlarmSettingListQuery("");
  const [isNoticeFirst, setNoticeFirst] = useState(true);

  useEffect(() => {
    if (alarmSetList.isSuccess) {
      setNoticeFirst(alarmSetList.data.data.HOME_MAIN === "NO" ? true : false);
    }
  }, [alarmSetList]);

  const [brand, setBrand] = useState<string>();

  const onChange = (brand: string) => {
    localStorage.setItem("@BRAND", brand);
    setBrand(brand);
  };

  useEffect(() => {
    const initBrand = localStorage.getItem("@BRAND");
    initBrand && setBrand(initBrand);
  }, []);

  // AS 종류별 카운트 API
  const { data, error, isLoading, isSuccess, isError } = useAsCountQuery(brand, { skip: employSkip });

  // AS 당일치 목록 API
  const asOneDayList = useAsOneDayListQuery(brand, { skip: employSkip });

  // 견적서 목록 API
  const estimateList = useEstimateListQuery(brand, { skip: employSkip });

  // 완료보고 목록 API
  const completeList = useCompleteListQuery(brand, { skip: employSkip });

  // 공지 목록 API
  const homeNoticeList = useNoticeListQuery({ skip: employSkip });

  useEffect(() => {
    if (asOneDayList.isSuccess) {
      dispatch(asListSet(asOneDayList.data));
    }
  }, [asOneDayList]);

  useEffect(() => {
    if (estimateList.isSuccess) {
      dispatch(estimateListSet(estimateList.data));
    }
  }, [estimateList]);

  useEffect(() => {
    if (completeList.isSuccess) {
      dispatch(completeListSet(completeList.data));
    }
  }, [completeList]);

  useEffect(() => {
    if (homeNoticeList.isSuccess) {
      dispatch(homeNoticeListSet(homeNoticeList.data));
    }
  }, [homeNoticeList]);

  // 홈 컴포넌트 마운트 시 navigation type 확인하여 슬라이드 초기화 여부 결정
  useEffect(() => {
    // 뒤로가기가 아닌 경우 (새로고침, 직접 URL 접근, 탭바 홈 버튼 클릭) 슬라이드 초기화
    const navigationType = (performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming)?.type;
    if (navigationType !== 'back_forward') {
      dispatch(setNoticeSlideIndex(0));
    }
  }, []);

  // ###################################### 본사 로직 END ######################################

  // ========================================== 매장용 로직 ==========================================
  const { storeSkip } = init;

  const [asTotalCount, setAsTotalCount] = useState<number>();
  const [storeAsList, setStoreAsList] = useState<Array<any>>();

  // AS 진행중인 목록 API
  const asProgressList = useAsProgressListQuery(userInfo.user_id, { skip: storeSkip });
  useEffect(() => {
    if (asProgressList.isSuccess) {
      setStoreAsList(asProgressList.data);
      setAsTotalCount(asProgressList.data.length);
    }
  }, [asProgressList]);

  const asRegiste = () => {
    // TODO navigate로 보내면 등록 후 home으로 와도 데이터가 안바껴있다.
    // 05/24 데이터 변함
    navigate("/as-register");
  };

  // ###################################### 매장용 로직 END ######################################

  // ========================================== 업체용 로직 ==========================================

  const { manuSkip } = init;
  // AS 진행 해야하는 목록 API
  const asMustList = useAsMustListQuery(userInfo.user_id, { skip: manuSkip });

  const asHopeList = useAsHopeListQuery(userInfo.user_id, { skip: manuSkip });

  const [asMustTotal, setAsMustTotal] = useState<number>();
  const [asHopeTotal, setAsHopeTotal] = useState<number>();

  useEffect(() => {
    if (asHopeList.isSuccess) {
      dispatch(asHopeListSet(asHopeList.data));
      setAsHopeTotal(asHopeList.data.length);
    }
  }, [asHopeList]);

  useEffect(() => {
    if (asMustList.isSuccess) {
      dispatch(asListSet(asMustList.data));
      setAsMustTotal(asMustList.data.length);
    }
  }, [asMustList]);

  // ###################################### 업체용 로직 END ######################################

  const viewChange = (userType: string) => {
    if (userType === "E") {
      return (
        <>
          {/* 본사 */}
          {/* 2차 개발 사항 */}
          <BoxLayout className={cn({ noticeFirst: isNoticeFirst ? true : false })}>
            <div>
              <Box pd="55px 15px 0">
                <div className="common-title">
                  <p className="tag">notice</p>
                  <div className="title-wrap title">
                    <h3>공지</h3>
                  </div>
                </div>
              </Box>
              {homeNoticeList.isSuccess && <MainBanner data={homeNoticeList.data.homeBasicNotice} />}

              <Box pd="55px 15px 0">
                <div className="common-title">
                  <div className="title-wrap sub-title">
                    <p>진행중 공지</p>
                  </div>
                </div>
              </Box>
              {homeNoticeList.isSuccess && <NoticeSlide data={homeNoticeList.data.homeExecuteNotice} />}
            </div>

            <BgBox>
              <div className="common-title">
                <p className="tag">a/s</p>
                <div className="title-wrap title">
                  <h3>애프터서비스</h3>
                </div>
              </div>
              {userInfo.brand === "CB" && (
                <div style={{ marginBottom: "5rem" }}>
                  <Select options={brands} defaultValue={brand} onChange={(e) => onChange(e.target.value)} />
                </div>
              )}
              {isSuccess && <AsStatusItem countArray={data.data[0]} brand={brand} />}
              <div className="common-title col-white">
                <div className="title-wrap sub-title">
                  <p>승인대기</p>
                </div>
              </div>
              {asOneDayList.isSuccess && estimateList.isSuccess && completeList.isSuccess && (
                <ApprovalListItem
                  registerNum={asOneDayList.data.totalCount}
                  estimateNum={estimateList.data.totalCount}
                  completeNum={completeList.data.totalCount}
                />
              )}
            </BgBox>
          </BoxLayout>
        </>
      );
    } else if (userType === "S") {
      return (
        <>
          {/* 매장 */}
          <Box pd="55px 15px 0">
            <div className="common-title">
              <p className="tag">notice</p>
              <div className="title-wrap title">
                <h3>공지</h3>
              </div>
            </div>
          </Box>
          {homeNoticeList.isSuccess && <MainBanner data={homeNoticeList.data.homeBasicNotice} />}

          <Box pd="55px 15px 0">
            <div className="common-title">
              <div className="title-wrap sub-title">
                <p>이행할 공지</p>
              </div>
            </div>
          </Box>
          {homeNoticeList.isSuccess && <NoticeSlide data={homeNoticeList.data.homeExecuteNotice} />}

          <BgBox>
            <div className="common-title">
              <p className="tag">a/s</p>
              <div className="title-wrap title">
                <h3>애프터서비스</h3>
                <p className="num">총 {asTotalCount}건</p>
              </div>
            </div>
            <ShopAsItem onClick={() => asRegiste()} storeAsList={storeAsList} />
          </BgBox>
        </>
      );
    } else if (userType === "M") {
      return (
        <>
          {/* 업체 */}
          <BgBox>
            <div className="common-title">
              <p className="tag">a/s</p>
              <div className="title-wrap title">
                <h3>견적서 등록</h3>
                <p className="num">총 {asMustTotal}건</p>
              </div>
            </div>
            <ComEstimateItem />
          </BgBox>
          <Box pd="50px 15px 40px">
            <div className="common-title">
              <div className="title-wrap sub-title">
                <p>방문 예정</p>
                <p className="num">총 {asHopeTotal}건</p>
              </div>
            </div>
            <ComVisitItem />
          </Box>
        </>
      );
    }
  };

  const logoChange = (userInfo: any) => {
    if (userInfo.user_type === "S" || userInfo.user_type === "E") {
      if (userInfo.brand === "M" || userInfo.brand === "X" || userInfo.brand === "I" || userInfo.brand === "A" || userInfo.brand === "V") {
        return (
          <>
            {/* 본사/매장 - 브랜드 코드 있는 사용자들 */}
            <img src={Logo[`${userInfo.brand}Black`]} alt={userInfo.brand} />
          </>
        );
      } else {
        return (
          <>
            {/* 본사 - 브랜드 제외 타 부서들 */}
            <img src={Logo["fnfBlack"]} alt="fnf" />
          </>
        );
      }
    } else {
      return (
        <>
          {/* 업체 */}
          <img src={Logo["fnfBlack"]} alt="fnf" />
        </>
      );
    }
  };

  return (
    <>
      {userInfo ? (
        <>
          <header className={cn({ hasAlarm: hasAlarm }, isScrollTop ? "" : "main-scrolled")}>
            <div>{userInfo && <h1 className="logo">{logoChange(userInfo)}</h1>}</div>
            {currentEnv !== "prod" && <h1 className="blink">{currentEnv}</h1>}
            <div className="btn-box">
              {userInfo.brand === "X" && (userInfo.user_type === "S" || userInfo.user_type === "E") && <BookMarkButton />}
              <AlarmButton />
              <IconButton btnName="마이페이지" className="user" onClick={() => navigate("/profile/" + userInfo.user_id)}>
                <SVG name="userBlack" />
              </IconButton>
            </div>
          </header>
          <Body type="main" isTabbar={true}>
            <VisualBox src={banner!}>
              <span className="sub-info">{userInfo.user_type === "E" ? "#F&F본사" : userInfo.user_type === "S" ? `#${storeTypeName}` : "#업체"}</span>
              <span className="user-name">
                {userInfo.dept_name} {userInfo.name}
              </span>
            </VisualBox>
            {viewChange(userInfo.user_type)}
          </Body>
        </>
      ) : (
        <Loading />
      )}
    </>
  );
}

const BoxLayout = styled.div`
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column-reverse;
  &.noticeFirst {
    flex-direction: column;
    > div:first-child {
      padding-bottom: 0;
    }
  }
  > div {
    padding-bottom: 40px;
  }
`;

const BgBox = styled.div`
  position: relative;
  padding: 65px 15px 0;
  &:after {
    content: "";
    z-index: -1;
    position: absolute;
    top: 200px;
    left: 0;
    bottom: 0;
    right: 0;
    display: block;
    background: ${({ theme }) => theme.color.main};
  }
`;

const VisualBox = styled.div<{ src: string }>`
  height: 184px;
  padding: 154px 15px 0;
  margin-left: 15px;
  ${(props) => props.src && `background: url(${props.src}) no-repeat 0 0;`}
  background-size: cover;
  color: #fff;
  font-size: 12px;
  text-align: right;
  > .user-name {
    position: relative;
    padding-left: 8px;
    margin-left: 8px;
    /* ${({ theme }) => theme.fontFamily.appleGothicNeo("bold", 700)}; */
    &:before {
      content: "";
      position: absolute;
      top: 50%;
      left: 0;
      display: block;
      width: 2px;
      height: 10px;
      margin-top: -5px;
      background-color: #fff;
    }
  }
`;

const TitleSet = styled.div`
  ${({ theme }) => theme.flexBox.flexMixin()};
  margin-bottom: 20px;
  > .title {
    font-size: 18px;
  }
  > .sub-info {
    color: ${({ theme }) => theme.color.secondary};
    font-size: 14px;
  }
`;

export default renewalHome;
